export var Title;
(function (Title) {
    Title["Dr"] = "DR";
    Title["Miss"] = "MISS";
    Title["Mr"] = "MR";
    Title["Mrs"] = "MRS";
    Title["Ms"] = "MS";
    Title["Other"] = "OTHER";
    Title["Unknown"] = "UNKNOWN";
})(Title || (Title = {}));
//# sourceMappingURL=Title.js.map